import { Fragment } from 'react';
import { PmiBodyTableCell } from 'shell/components/shared/table-custom/body';
import { PmiTableRow } from 'shell/components/shared/table/row';
import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton, Tooltip } from '@mui/material';
import { Edit, Visibility } from '@mui/icons-material';
import { DocumentSerieItemVM } from 'civil-status/view-models/document-serie-list';
import { CivilStatusAuthorizations } from 'shell/authorizations/civil-status';
import { useActionAuthorization } from 'shell/hooks/use-action-authorization';

export const authsRowDocumentSerie = {
  read: [CivilStatusAuthorizations.DocumentiSerieQuery],
  delete: [CivilStatusAuthorizations.DocumentiSerieDelete],
  update: [CivilStatusAuthorizations.DocumentiSerieUpdate],
  add: [CivilStatusAuthorizations.DocumentiSerieAdd],
};
interface TableRowComponentProps {
  item: DocumentSerieItemVM;
  onTrashPress: (item: DocumentSerieItemVM) => void;
  onVisibilityPress: (item: DocumentSerieItemVM) => void;
  onEditPress: (item: DocumentSerieItemVM) => void;
}

const TableRowComponent = ({
  item,
  onTrashPress,
  onVisibilityPress,
  onEditPress,
}: TableRowComponentProps): React.ReactElement => {
  const auths = useActionAuthorization(authsRowDocumentSerie);

  return (
    <Fragment>
      <PmiTableRow>
        <PmiBodyTableCell scope="row">{item.number}</PmiBodyTableCell>
        <PmiBodyTableCell scope="row">{item.description}</PmiBodyTableCell>
        <PmiBodyTableCell scope="row">
          <div className="pmi-d-flex">
            <Tooltip
              arrow
              title={
                auths.read
                  ? 'Visualizza'
                  : "Non si ha l'autorizzazione per accedere a questa funzionalità"
              }
            >
              <span>
                <IconButton
                  aria-label="visualizza"
                  component="span"
                  onClick={() => onVisibilityPress(item)}
                  disabled={!auths.read}
                >
                  <Visibility />
                </IconButton>
              </span>
            </Tooltip>
            <Tooltip
              arrow
              title={
                auths.update
                  ? 'Aggiorna'
                  : "Non si ha l'autorizzazione per accedere a questa funzionalità"
              }
            >
              <span>
                <IconButton
                  aria-label="modifica"
                  component="span"
                  onClick={() => onEditPress(item)}
                  disabled={!auths.update}
                >
                  <Edit />
                </IconButton>
              </span>
            </Tooltip>
            <Tooltip
              arrow
              title={
                auths.delete
                  ? 'Elimina'
                  : "Non si ha l'autorizzazione per accedere a questa funzionalità"
              }
            >
              <span>
                <IconButton
                  color="error"
                  aria-label="elimina"
                  component="span"
                  disabled={!auths.delete}
                  onClick={() => onTrashPress(item)}
                >
                  <DeleteIcon />
                </IconButton>
              </span>
            </Tooltip>
          </div>
        </PmiBodyTableCell>
      </PmiTableRow>
    </Fragment>
  );
};

TableRowComponent.displayName = 'Table row component';

export default TableRowComponent;
